module.exports = __webpack_public_path__ + "img/no_friends.b2ba2866.png";